import { render, staticRenderFns } from "./addGomunAdviceDialog.vue?vue&type=template&id=4efb44de"
import script from "./addGomunAdviceDialog.vue?vue&type=script&lang=js"
export * from "./addGomunAdviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports